const { postData } = require('../fetch')

function getAuthorizationHeader (token) {
  return token ? { Authorization: `Bearer ${token}` } : {}
}

exports.callAPI = (path, bodyJson, token, options) => postData(path, bodyJson, getAuthorizationHeader(token), options)